const ENV = process.env.ENV

// Mapping of model IDs to their display names used in query params
const modelNames: Record<number, string> = {
  21: "MAZDA 2",
  2: "MAZDA 3",
  3: "MAZDA 3",
  17: "MAZDA CX-3",
  6: "MAZDA CX-30",
  12: "MAZDA CX5",
  13: "MAZDA 6",
  1001: "MAZDA CX90",
  1005: "The All New MAZDA CX-5",
}

// Production base paths vs. non-production (all others) base paths
const TEST_DRIVE_BASE_PROD =
  "https://yomanappointments.mazda.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/b5UxgxdPhU"
const TEST_DRIVE_BASE_NON_PROD =
  "https://yoman.co.il/sites/41eff03c-010f-4b78-85e9-2cd53d95195b/dJ7QCZfVCd"

const MEETING_BASE_PROD =
  "https://yomanappointments.mazda.co.il/sites/67bc7776-71a6-4e11-a839-5ba94be3b6b6/3T791irzH0"
const MEETING_BASE_NON_PROD =
  "https://yoman.co.il/sites/41eff03c-010f-4b78-85e9-2cd53d95195b/WfhPdeCVdz"

export const getTestDriveIframeLink = (modelId?: number | null) => {
  const base =
    ENV === "production" ? TEST_DRIVE_BASE_PROD : TEST_DRIVE_BASE_NON_PROD

  const name = modelId ? modelNames[modelId] : undefined
  if (name) {
    return `${base}?sitesGroupID=MAZ&RGP=${name}&langbar=0`
  }

  return `${base}?sitesGroupID=MAZ&langbar=0`
}

export const getMeetingIframeLink = (modelId?: number | null) => {
  const base = ENV === "production" ? MEETING_BASE_PROD : MEETING_BASE_NON_PROD

  const name = modelId ? modelNames[modelId] : undefined
  if (name) {
    return `${base}?sitesGroupID=MAZ&RG=${name}&langbar=0`
  }

  return `${base}?sitesGroupID=MAZ&langbar=0`
}

export const isModelHasTestDriveIframe = (modelId?: number) => {
  if (!modelId) return false
  return [21, 2, 3, 17, 6, 12, 13, 1005].includes(modelId)
}
export const isModelHasMeetingIframe = (modelId?: number) => {
  if (!modelId) return false
  return [21, 2, 3, 17, 6, 12, 13, 1001, 1005].includes(modelId)
}
